import * as React from 'react';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { ValidationError } from '@nextinq.public/usable-form/lib/types';
import { colors } from '../themes';
import { Icon } from 'semantic-ui-react';
import { sizes } from '../themes';
import cx from 'classnames';
import { ErrorItem } from './error-item';

const Wrapper = styled.section`
  display: grid;
  grid-gap: ${sizes.margins.small};
  margin-bottom: ${sizes.margins.huge};
  .ui.input,
  .ui.dropdown {
    width: 100%;
  }
`;

const Label = styled.label``;
const HelpText = styled.div`
  color: ${colors.grey.greyLighter};
  font-size: smaller;
`;
const FieldWrapper = styled.div``;

export interface InputWrapperProps {
  label?: string | null;
  children?: ReactNode;
  required?: boolean;
  touched?: boolean;
  error?: ValidationError | null | undefined;
  helperText?: string;
}

export function InputWrapper(props: InputWrapperProps) {
  const { error, touched, label, required, children, helperText } = props;
  const fieldClasses = cx('field', { error, required });
  return (
    <Wrapper className={fieldClasses}>
      <Label>{label}</Label>
      <FieldWrapper>{children}</FieldWrapper>
      {error && touched && <ErrorItem error={error} />}
      {helperText && (
        <HelpText>
          <Icon name="help circle" size="small" />
          {helperText}
        </HelpText>
      )}
    </Wrapper>
  );
}
